<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>reviews</md-icon>
          </div>
          <h4 class="title">Create Review Request</h4>
        </md-card-header>

        <md-card-content>
          
          <!-- REVIEW REQUEST FORM -->
          <form @submit.prevent="submitReviewRequest">

            <!-- Email -->
            <md-field>
              <label>Email</label>
              <md-input 
                v-model="form.email" 
                placeholder="Enter user email"
              />
            </md-field>

            <!-- User Name (Read-only display) -->
            <md-field v-if="parentInfo">
              <label>Name</label>
              <md-input 
                 v-model="parentName"
              />
            </md-field>

            <!-- Email Subject -->
            <md-field>
              <label>Email Subject</label>
              <md-input 
                v-model="form.subject" 
                placeholder="Email subject"
              />
            </md-field>

            <!-- Email Body (vue2-editor) -->
            <label><b>Email Body</b></label>
            <vue-editor v-model="form.body"></vue-editor>

            <md-button 
              class="md-success md-raised submit-btn"
              type="submit"
              :disabled="isDisabled"
            >
              Create Review Request 
              <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>

          </form>
        </md-card-content>

      </md-card>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

export default {
  components: { VueEditor },

  data() {
    const orderNumber = this.$route.query.orderNumber || "12345";
    return {
      isDisabled: false,
      parentInfo: null,
      parentName: "",
      form: {
        email: this.$route.query.email || "",
        subject: "Your Order Confirmation",
        body: `<p>Your order ${orderNumber} has been shipped.</p>`
      }
    };
  },

  methods: {
    // Submit review request
    submitReviewRequest() {
      this.isDisabled = true;
      this.form.name = this.parentName || "";
      UsersDataService.createReviewRequest(this.form)
        .then(() => {
          this.isDisabled = false;
          this.$toast.success("Review request created successfully!");
          this.$router.push('/kid/parents');
        })
        .catch(e => {
          this.isDisabled = false;
          this.$toast.error(e.response?.data?.respones_msg || "Error creating review request");
        });
    },

    getParentInfo() {
      if (!this.form.email) {
        this.$toast.error("Email is required");
        this.$router.push('/kid/parents');
        return;
      }

      this.isDisabled = true;
      
      let data = {
        email: this.form.email
      };

      UsersDataService.kidsParentDetail(data)
        .then((response) => {
          this.parentInfo = response.data.data;
          this.parentName = this.parentInfo.name
          //this.populateEmailTemplate();
          this.isDisabled = false;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error fetching data");
          this.isDisabled = false;
        });
    },

    populateEmailTemplate() {
      if (!this.parentInfo) return;

      const userName = this.parentInfo.name || this.parentInfo.email;

      // Check if delegated access user
      if (this.parentInfo.delegatedAccessUser === true) {
        const delegatedUserName =
          this.parentInfo.delegatedByUserName || "another user";

        this.form.subject = "How is Wingio working for your family?";

        this.form.body = `
          <p>Hi ${userName},</p>

          <p>
            We noticed you've delegated parental controls to
            <strong>${delegatedUserName}</strong>.
            We hope this is making it easier to manage your family's digital safety!
          </p>

          <p>
            As a small team, we rely on word-of-mouth.
            Would you and your co-user mind taking 1 minute to share your experience on Trustpilot?
          </p>

          <p>
            <a href="https://uk.trustpilot.com/review/mywingio.com">
              Leave a review on Trustpilot
            </a>
          </p>

          <p>
            Your feedback helps other parents find us and helps us know what features to build next.
          </p>

          <p>
            Best regards,<br>
            Xavier Dijo<br>
            Founder, Wingio<br>
            Building a safer digital world for our children.
          </p>
        `;
      } else {
        // Regular user template
        this.form.subject = "Your Wingio has arrived! (Quick question...)";

        this.form.body = `
          <p>Hi ${userName},</p>

          <p>
            I saw that your Wingio device was delivered — I hope you're excited to get started!
          </p>

          <p>
            My goal is to make sure Wingio provides the peace of mind your family deserves.
            Before you dive in, I wanted to reach out personally to make sure you have everything you need.
          </p>

          <h3>🛠️ Need help with setup?</h3>

          <p>
            If you run into any "tech hurdles" while connecting your devices,
            please don't struggle in silence. You can:
          </p>

          <ul>
            <li>
              View our Quick Start Guide:
              <a href="https://www.mywingio.com/how-it-works">
                https://www.mywingio.com/how-it-works
              </a>
            </li>

            <li>
              Visit the Help Center:
              <a href="https://www.mywingio.com/faq">
                https://www.mywingio.com/faq
              </a>
            </li>

            <li>
              Reply directly to this email —
              I (or one of my team) will get back to you personally.
            </li>
          </ul>

          <h3>⭐ A small favor...</h3>

          <p>
            As a founder, seeing Wingio in the hands of more families is incredibly rewarding.
            If your setup went smoothly and you're happy with the experience so far,
            would you mind sharing a quick review on Trustpilot?
          </p>

          <p>
            You will receive an official invitation from them shortly via email.
            It only takes 30 seconds, but for a growing company like ours,
            it makes a world of difference in helping other parents find us.
          </p>

          <p>
            Thank you for trusting Wingio with your family's digital safety.
          </p>

          <p>
            Best regards,<br>
            Xavier Dijo<br>
            Founder, Wingio
          </p>
        `;
      }
    },

    resetForm() {
      this.form = {
        email: "",
        subject: "",
        body: "",
      };
    }
  },

  beforeMount() {
    this.getParentInfo();
  },
};
</script>

<style scoped>
.submit-btn {
  margin-top: 20px;
}

/* vue2-editor / Quill spacing fix */
::v-deep .ql-editor {
  min-height: 250px;
  line-height: 1.4;
  padding: 12px 15px;
}

/* Remove huge paragraph gaps */
::v-deep .ql-editor p,
::v-deep .ql-editor h1,
::v-deep .ql-editor h2,
::v-deep .ql-editor h3,
::v-deep .ql-editor h4,
::v-deep .ql-editor h5,
::v-deep .ql-editor h6 {
  margin-top: 0 !important;
  margin-bottom: 8px !important;
}

/* Lists */
::v-deep .ql-editor ul,
::v-deep .ql-editor ol {
  margin-top: 0 !important;
  margin-bottom: 8px !important;
  padding-left: 20px;
}

::v-deep .ql-editor li {
  margin-bottom: 4px;
}

/* Prevent extra empty line spacing */
::v-deep .ql-editor p:empty {
  display: none;
}
</style>